<template>
  <a-card :bordered="false" class="m-t-10">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">报销单审核</span>
  </a-card>
  <a-card :bordered="false">
    <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">报销单详情</p>
    <div class="s_p24">
      <p class="s_c333  s_lin_h35">提交对象：{{orderData.create_role_name}}</p>
      <p class="s_c333  s_lin_h35">审核对象： {{orderData.examine_store_name}}</p>
      <p class="s_c333  s_lin_h35">报销单状态：{{orderData.status_name}}</p>
      <p class="s_c333  s_lin_h35">提交时间：{{orderData.create_time}}</p>
      <p class="s_c333  s_lin_h35" v-if='orderData.status == 1'>审批时间：{{orderData.update_time}}</p>
      <p class="s_c333  s_lin_h35" v-if='orderData.status == 1'>审批者：{{orderData.examine_name}}</p>
      <p class="s_c333  s_lin_h35" v-if='orderData.status == 2'>取消时间：{{orderData.update_time}}</p>
      <p class="s_c333  s_lin_h35" v-if='orderData.status == 3'>超时时间：{{orderData.update_time}}</p>
      <p class="s_c333  s_lin_h35">报销单号：{{orderData.bill_no}}</p>
      <p class="s_c333  s_lin_h35">报销单类型：{{orderData.bill_type}}</p>
    </div>
    <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">报销内容</p>
    <div class="m-t-25 m-b-25">
      <a-button class="width-120 m-r-20" block :type="active == 'point' ? 'primary':''" @click="active = 'point'">积分</a-button>
      <a-button class="width-120 m-r-20" block :type="active == 'coupon' ? 'primary':''" @click="active = 'coupon'">优惠券</a-button>
      <a-button class="width-120" block :type="active == 'gift' ? 'primary':''" @click="active = 'gift'">礼品</a-button>
    </div>
    <div class="fz-16" v-if="active == 'point'"><span class="s_font_b" >积分：</span>{{orderData.point_num}}积分</div>
    <div v-if="active == 'coupon'"> 
      <div class="m-b-20">
        <a-select v-model:value="coupon_type" :style="{width:'180px'}" placeholder="请选择" @change='pageSearchChange'>
          <a-select-option value="">全部类型</a-select-option>
          <a-select-option :value="2">现金券</a-select-option>
          <a-select-option :value="3">代金券</a-select-option>
          <a-select-option :value="1">折扣券</a-select-option>
        </a-select>
        <span class="m-r-20 m-l-20">优惠券：共{{couponNum}}张</span>
        <span>抵扣金额：{{couponPrice}}元</span>
      </div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='coupon_name' :columns='columnsCoupon' :data-source='couponData'></a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="searchCoupon.page" :page-size="searchCoupon.limit" :total="couponTotal" @change="(page, pageSize)=>pageCurrentChange(page, pageSize,'coupon')" @showSizeChange="(current, size)=>pageSizeChange(current, size,'coupon')" :show-total="total => `总数: ${total} `"  />
    </div>
    <a-table v-if="active == 'gift'" :pagination='false' :loading='listLoading' bordered rowKey='exchange_name' :columns='columnsGift' :data-source='giftData'>
      <template v-slot:gift_name="{ record }">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+'/'+(record.exchange_image)" alt="" style="width:50px;height:50px">
          </template>
          <template #description>
            <p class="s_omit2" style="width: 320px;">{{record.exchange_name}}</p>
          </template>
        </a-card-meta>
      </template>
    </a-table>
    <a-pagination v-if="active == 'gift'" :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="searchGift.page" :page-size="searchGift.limit" :total="giftTotal" @change="(page, pageSize)=>pageCurrentChange(page, pageSize,'gift')" @showSizeChange="(current, size)=>pageSizeChange(current, size,'gift')" :show-total="total => `总数: ${total} `" />
    <div class="m-t-25">
      <a-button class="width-120 m-r-20" block @click="()=>{$router.go(-1)}">返回</a-button>
      <a-button class="width-120" block type="primary" v-has:reimburseSubmit="onSubmit" v-if='orderData.status == 0'>确定报销</a-button>
    </div>
  </a-card>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { LeftOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { getReimbursmentSingleDetails,getReimbursmentSingleCoupon,getReimbursmentSingleGift,reimbursmentAudit } from "@/api/reimbursement";
import { iscode } from "@/utils/app";
import store from "@/store";
let defSearch = {
  page:1,
  limit:5
}
export default {
  components: { LeftOutlined },
  setup() {
    const searchCoupon = ref({ ...defSearch });
    const searchGift = ref({ ...defSearch });
    const state = reactive({
      info: store.state.user.info,
      active:'point',
      couponData:[],
      giftData:[],
      type:'',
      couponTotal:0,
      giftTotal:0,
      orderData:{},
      coupon_type:'',
      couponNum:0,
      couponPrice:0
    });
    let columnsCoupon = [
      {
        title: "优惠券名称",
        dataIndex: "coupon_name",
        key: "coupon_name",
      },
      {
        title: "优惠券类型",
        dataIndex: "coupon_type_name",
        key: "coupon_type_name",
      },
      {
        title: "券号",
        dataIndex: "coupon_sn",
        key: "coupon_sn",
      },
      {
        title: "抵扣金额（元）",
        dataIndex: "coupon_price",
        key: "coupon_price",
      },
    ];
    let columnsGift = [
      {
        title: "礼品信息",
        dataIndex: "gift_name",
        key: "gift_name",
        slots: { customRender: "gift_name" },
      },
      {
            title: "规格",
            dataIndex: "exchange_spec_value",
            key: "exchange_spec_value",
            customRender:function({record}){
              return record.exchange_spec_value || '-'
            }
          },
      {
        title: "数量（个）",
        dataIndex: "num",
        key: "num",
      }
    ];
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      searchCoupon.value = { ...searchCoupon.value, page: 1 };
      getCoupon();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize,type) => {
      if(type == 'coupon'){
        searchCoupon.value.page = page;
        getCoupon();
      }else{
        searchGift.value.page = page;
        getGift();
      }
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit,type) => {
      if(type == 'coupon'){
        searchCoupon.value.page = 1;
        searchCoupon.value.limit = limit;
        getCoupon();
      }else{
        searchGift.value.page = 1;
        searchGift.value.limit = limit;
        getGift();
      }
    };
    //获取详情
    const getMore = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getReimbursmentSingleDetails({ id: $route.query.id }).then((res) => res.data);
      if (iscode(res)) {
        state.orderData = res.data;
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    // 获取优惠券列表
    const getCoupon = async () => {
      let res = await getReimbursmentSingleCoupon({ ...searchCoupon.value,coupon_type:state.coupon_type,id: $route.query.id }).then((res) => res.data);
      if (iscode(res)) {
        state.couponData = res.data.data;
        state.couponTotal = res.data.total;
        state.couponNum = res.data.coupon_num
        state.couponPrice = res.data.coupon_price
      } else {
        message.error(res.msg);
      }
    };
    // 获取礼品列表
    const getGift = async () => {
      let res = await getReimbursmentSingleGift({...searchGift.value, id: $route.query.id }).then((res) => res.data);
      if (iscode(res)) {
        state.giftData = res.data.data;
        state.giftTotal = res.data.total
      } else {
        message.error(res.msg);
      }
    };
    //提交
    const onSubmit = () => {
      $Modal.confirm({
        centered:true,
        title:'确定报销吗？',
        content: '确定报销后不可更改', 
        async onOk(){
          const hide = message.loading("正在加载中...", 0);
          let res = await reimbursmentAudit({bill_no:state.orderData.bill_no}).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            setTimeout(() => {
              $router.go(-1);
            }, 2000);
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        }
      })
    };
    onMounted(() => {
      getMore();
      getCoupon();
      getGift()
    });
    return {
      columnsGift,
      columnsCoupon,
      ...toRefs(state),
      onSubmit,
      searchGift,
      searchCoupon,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange
    };
  },
};
</script>
